export enum API_ERROR_CODES {
  CLIENT_NOT_SUPPORTED = 'CLIENT_NOT_SUPPORTED',
}
